import React from 'react'
import { FormGroup, FormControl, Row, Col } from 'react-bootstrap'
import VirtualizedSelect from 'react-virtualized-select'
import 'react-select/dist/react-select.css'
import 'react-virtualized-select/styles.css'
import HoopSwitch from '../ToggleSwitch'


function WaiverTab(props){
  const {
    organization_waiver,
    custom_waiver,
    renderSubmitButtons,
    waiver_type,
    onChangeWaiverType,
    handleCustomWaiverChange,
    disabled,
    league,
    orgUDFS,
    programUDFs,
    handleUDFs,
  } = props

  return (
    <div className="modal-formfields">
      <Row className="coloured-modal">
        <Col lg={12} sm={12}>
          <h3>Fields & Waivers</h3>
          {
            orgUDFS && !league &&
            <Row style={{ marginTop: '24px' }}>
              <Col lg={12} sm={12}>
                <FormGroup>
                  <div className="custom-fields-block">
                    <div className="custom-fields-label">Add Custom Fields</div>
                    <div className="custom-fields-help">
                      Add UDFs to your organization from your Profile. Standard enrolment fields are Parent1 and Parent2 name, phone, email; Player name, gender, DOB, contact info, address, city, province/state, postal code/zip code, current school, and notes.
                    </div>
                  </div>
                  <VirtualizedSelect
                    className="udf-multi-select opaque-grey"
                    name="orgUDFs"
                    value={programUDFs}
                    options={orgUDFS}
                    multi={true}
                    onChange={(e) => handleUDFs(e)}
                    placeholder="---"
                  />
                </FormGroup>
              </Col>
            </Row>
          }
          <Row>
            <Col lg={6} sm={12}>
              <div className="waiver-section-label">Waivers</div>
              <div className="waiver-toggle-card">
                <div className="waiver-toggle-copy">
                  <div className="waiver-toggle-title">Waiver type</div>
                  <div className="waiver-toggle-subtitle">Choose the organization waiver or write a custom one for this program.</div>
                </div>
                <div className="waiver-toggle-control">
                  <span className={`waiver-toggle-label ${waiver_type === "0" ? "is-active" : ""}`}>Standard</span>
                  <HoopSwitch
                    checked={waiver_type === "1"}
                    onChange={(e) => onChangeWaiverType({ target: { value: e.target.checked ? "1" : "0" } })}
                    disabled={disabled}
                  />
                  <span className={`waiver-toggle-label ${waiver_type === "1" ? "is-active" : ""}`}>Custom</span>
                </div>
              </div>
            </Col>
          </Row>
          <Row style={{marginTop: "3%"}}>
            <Col lg={12} sm={12}>
              <FormGroup>
                {
                  waiver_type === "0" ? (
                    <FormControl 
                      className="opaque-grey" 
                      name="organization_waiver"
                      componentClass="textarea"
                      id="organization_waiver"
                      value={organization_waiver}
                      rows={10}
                      disabled={disabled}
                    /> 
                    ) : (
                    <FormControl 
                      className="opaque-grey"
                      name="custom_waiver"
                      componentClass="textarea"
                      id="custom_waiver"
                      value={custom_waiver}
                      onChange={e => handleCustomWaiverChange(e)}
                      rows={10}
                    disabled={disabled}
                    />
                )}
                </FormGroup>
            </Col>
          </Row>
          <Row className="btn-flex">
            {renderSubmitButtons()}
          </Row>
        </Col>
      </Row>
    </div>
  )
}


export default WaiverTab
